import { combineReducers } from "redux";
import * as authReducer from "./user";
import * as alertReducer from "./alert";
import * as appReducer from "./app";
import * as practiceReducer from "./practice";
import * as messageReducer from './message';
import * as regionsReducer from "./regions";
import * as openDentalReducer from "./openDental";

export default () =>
	combineReducers({
		...authReducer,
		...alertReducer,
		...appReducer,
		...practiceReducer,
		...messageReducer,
		...regionsReducer,
		...openDentalReducer
	});


